import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Lesson } from 'core/models/course-content.model';
import { LessonHeader } from 'components/lesson-header/lesson-header';

@Component({
  selector: 'app-pdf-preview',
  standalone: true,
  imports: [CommonModule, LessonHeader],
  templateUrl: './pdf-preview.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'w-full h-full flex flex-col',
  },
})
export class PdfPreview {
  private readonly sanitizer = inject(DomSanitizer);

  @Input({ required: true }) lesson!: Lesson;

  protected get safePdfUrl(): SafeResourceUrl | null {
    if (!this.lesson?.pdfUrl) {
      return null;
    }

    const url = this.lesson.pdfUrl.trim();

    // Validar se a URL parece ser uma URL válida de PDF
    const isValidPdfUrl =
      url.endsWith('.pdf') ||
      url.includes('.pdf?') ||
      url.includes('.pdf#') ||
      url.startsWith('http://') ||
      url.startsWith('https://');

    // Se não for uma URL válida de PDF, retornar null para exibir mensagem de erro
    if (!isValidPdfUrl) {
      return null;
    }

    try {
      const hasHash = url.includes('#');
      const pdfUrlWithParams = hasHash
        ? `${url}&toolbar=0&navpanes=1&scrollbar=0&view=FitH`
        : `${url}#toolbar=0&navpanes=1&scrollbar=0&view=FitH`;

      return this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrlWithParams);
    } catch (error) {
      // Se houver erro ao sanitizar, retornar null
      console.error('Erro ao sanitizar URL do PDF:', error);
      return null;
    }
  }
}
